import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import FAQ from '@/components/feature/FAQ';

export default function HeroSection() {
  const featuredComics = comics.filter(c => c.rating >= 9.7).slice(0, 4);

  return (
    <section className="relative w-full overflow-hidden" aria-label="网站 banner">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20illustration%20of%20a%20cozy%20reading%20room%20with%20manga%20bookshelves%2C%20warm%20golden%20ambient%20lighting%2C%20soft%20shadows%2C%20creative%20atmosphere%2C%20pastel%20color%20palette%20with%20coral%20and%20amber%20accents%2C%20abstract%20geometric%20shapes%2C%20no%20text&width=1600&height=700&seq=hero-bg-comic&orientation=landscape"
          alt="八仔漫画网 - 在线阅读背景"
          className="w-full h-full object-cover object-center"
          width={1600}
          height={700}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            海量精品漫画<span className="text-accent-400">免费看</span>
          </h1>
          <p className="text-sm md:text-lg text-background-200/90 max-w-2xl mb-8 leading-relaxed">
            八仔漫画网为您提供<strong>伪装学渣漫画在线免费阅读</strong>，无需付费，无广告干扰，纯净阅读环境，让您沉浸于精彩剧情中。热门国漫、日漫一网打尽，每日更新。
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/全部"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              立即阅读 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-12 w-full max-w-3xl">
            {[
              { icon: 'ri-book-read-line', label: '精品漫画', value: '1000+' },
              { icon: 'ri-user-heart-line', label: '日活用户', value: '50万+' },
              { icon: 'ri-refresh-line', label: '每日更新', value: '50+' },
              { icon: 'ri-shield-check-line', label: '无广告', value: '纯净阅读' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col items-center gap-1 p-3 rounded-lg bg-background-50/10 backdrop-blur-sm">
                <i className={`${stat.icon} text-accent-400 text-xl md:text-2xl`}></i>
                <span className="text-background-50 font-bold text-sm md:text-lg">{stat.value}</span>
                <span className="text-background-200/80 text-xs">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pb-12">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50">编辑精选</h2>
            <p className="text-sm text-background-200/80 mt-1">高分必看漫画推荐</p>
          </div>
          <Link to="/category/全部" className="text-sm text-accent-400 hover:text-accent-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block bg-background-50/10 backdrop-blur-sm rounded-lg overflow-hidden border border-background-50/10 hover:border-accent-400/50 transition-all cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden bg-background-800/30">
                <img
                  src={comic.cover}
                  alt={`${comic.title}漫画封面`}
                  title={`${comic.title} - 高分必看漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width={300}
                  height={420}
                />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-heading font-bold text-background-50 line-clamp-1">{comic.title}</h3>
                <div className="flex items-center gap-1 mt-1">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span className="text-xs text-accent-400 font-medium">{comic.rating}</span>
                  <span className="text-xs text-background-300 ml-1">{comic.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}